import { Shield } from "lucide-react";

const MeetingSecuritySection = () => {
  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Enhanced Meeting Security</h2>
      <div className="bg-gradient-to-r from-[#069E50]/10 to-[#069E50]/5 rounded-lg p-8 border border-[#069E50]/20">
        <div className="flex items-start gap-4">
          <Shield className="h-8 w-8 text-[#069E50] mt-1 flex-shrink-0" />
          <div>
            <h3 className="text-xl font-semibold mb-3 text-[#069E50]">Superior Audio Security with Desktop Speakers</h3>
            <p className="text-muted-foreground text-lg leading-relaxed">
              The internal speaker positioned within a few feet of meeting attendees enables significantly lower volume levels compared to traditional in-ceiling speaker solutions. This proximity-based design provides enhanced meeting room security by reducing audio spillover into adjacent spaces, ensuring confidential discussions remain private while maintaining crystal-clear audio quality for all participants.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingSecuritySection;
